import { axios, addHeader } from '@/api/index.js'
const user = {
  getUserInfo: accessToken => {
    return axios.get('/user/getUserInfo', addHeader(accessToken), { param: null })
  },
  updateUserTerms: accessToken => {
    return axios.post('/user/updateUserTerms', null, addHeader(accessToken))
  },
  changePassword: (payload, accessToken) => {
    return axios.post('/user/changePassword', payload, addHeader(accessToken))
  },
  getUserNmis: accessToken => {
    return axios.get('/user/getAllUserNmis', addHeader(accessToken))
  },
  getUserNmisForBillHistory: accessToken => {
    return axios.get('/user/getAllUserNmisForBillHistory', addHeader(accessToken))
  },
  getUserNmisByCustomer: accessToken => {
    return axios.get('/user/getAllUserNmisByCustomer', addHeader(accessToken))
  },
  getUserBillingGroups: accessToken => {
    return axios.get('/user/getAllUserBillingGroups', addHeader(accessToken))
  },
  getUsers: accessToken => {
    return axios.get('/user/getUsers', addHeader(accessToken))
  },
  saveUser: (payload, accessToken) => {
    return axios.post('/user/saveUser', payload, addHeader(accessToken))
  },
  deleteUser: (payload, accessToken) => {
    return axios.get('/user/deleteUser?id=' + payload, addHeader(accessToken))
  },
}

export default user
